import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/fatturatoHotels';
import { selectors, DEFAULT_STATE } from '../reducers/fatturatoHotels';
import api from '../apis/fatturatoHotels';

const sagas = helper.createSagas('fatturatoHotels', actionTypes, actions, api, selectors, DEFAULT_STATE);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [
    ...defaultSagas
];